import {BaseModel} from "../base";
import {adminOrder} from "../../services/admin_order";

class AdminOrderModel extends BaseModel {

    /**
     * @param {object} data The resources data
     * @description
     * Update the data in according of the data parameter
     *
     * @returns {array} Returns the updated array
     */
    $update(data) {

        return this.$put('self', {}, data).then((res) => {
                return this.constructor(res);
            }
        );
    }


    static $query(params) {
        return adminOrder.query(params);
    }


    $refetch() {
        return new Promise((resolve, reject) => {
            this.$flush('self');
            this.$get('self').then((res) => {
                    this.constructor(res);
                    return resolve(this);
                }
                , err => reject(err));
        });
    }
}

export {
    AdminOrderModel
}